import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { useCartPreview } from '~/composables/useCheckout/modules/useCartPreview';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzProgressBar',
  props: {
    maxPriceObject: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency;
    var _useCartPreview = useCartPreview(),
      discountedSubtotal = _useCartPreview.discountedSubtotal;
    var centDiscountedSubtotal = computed(function () {
      return discountedSubtotal.value * 100;
    });
    var currentLimit = computed(function () {
      var centAmounts = props.maxPriceObject.map(function (rate) {
        return rate.centAmount;
      }).sort(function (a, b) {
        return a - b;
      });
      var index = 0;
      for (var i = 0; i < centAmounts.length; i++) {
        if (centAmounts[i] > centDiscountedSubtotal.value) {
          index = i;
          break;
        }
      }
      return props.maxPriceObject[index];
    });
    var thresholdPrice = computed(function () {
      var _currentLimit$value;
      return ((_currentLimit$value = currentLimit.value) === null || _currentLimit$value === void 0 ? void 0 : _currentLimit$value.centAmount) || 0;
    });
    var remainingAmount = computed(function () {
      if (centDiscountedSubtotal.value >= thresholdPrice.value) {
        return 0;
      } else {
        return parseFloat(((thresholdPrice.value - centDiscountedSubtotal.value) / 100).toFixed(2));
      }
    });
    var progressAmount = computed(function () {
      return parseFloat((centDiscountedSubtotal.value / thresholdPrice.value * 100).toFixed(2));
    });
    return {
      __sfc: true,
      props: props,
      currency: currency,
      discountedSubtotal: discountedSubtotal,
      centDiscountedSubtotal: centDiscountedSubtotal,
      currentLimit: currentLimit,
      thresholdPrice: thresholdPrice,
      remainingAmount: remainingAmount,
      progressAmount: progressAmount
    };
  }
});